import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Link } from 'react-router-dom';
import { Card, Button } from 'react-bootstrap';
import IMDBSVG from '../assets/imdb.svg';
import LISVG from '../assets/linkedin-original.svg';
import nick from '../assets/NicholasOrtiz.jpeg';

export default function About() {
  // 0 = hidden, 1 = mission statement centered on screen, 2 = everything revealed
  const [phase, setPhase] = useState(0);
  const [introOffset, setIntroOffset] = useState(0);
  const quoteRef = useRef(null);
  const show = phase === 2;
  const CONTACT_HREF =
  "mailto:contact@secondteamproductions.com?subject=Studio%20Services%20Inquiry";

  // measure how far the quote must move to sit at the vertical center of the viewport
  useLayoutEffect(() => {
    const rect = quoteRef.current.getBoundingClientRect();
    setIntroOffset(window.innerHeight / 2 - (rect.top + rect.height / 2));
  }, []);

  useEffect(() => {
    const t1 = setTimeout(() => setPhase(1), 100);
    const t2 = setTimeout(() => setPhase(2), 3200);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  // staggered fade + slide up
  const reveal = (delay = 0) => ({
    opacity: show ? 1 : 0,
    transform: show ? 'translateY(0)' : 'translateY(24px)',
    transition: 'opacity 0.7s ease, transform 0.7s ease',
    transitionDelay: `${delay}s`,
  });

  return (
    <div style={{ marginBottom: '7%' }}>
      <div className="d-flex justify-content-center" style={reveal(0)}>
        <h1>About Us</h1>
      </div>
          {/* Mission pull-quote */}
          <div style={{ marginLeft: '8%', marginRight: '8%' }}>
      <blockquote
        ref={quoteRef}
        className="text-start"
        style={{
         marginTop: '1.5rem',
          marginBottom: '2.5rem',
          marginLeft: 'auto',
          marginRight: 'auto',
          maxWidth: '800px',
          paddingLeft: '1.5rem',
          borderLeft: '4px solid rgb(105, 13, 13, 0.6)', // swap for your brand accent
          fontSize: '1.25rem',
          fontStyle: 'italic',
          opacity: phase === 0 ? 0 : 1,
          transform:
            phase === 2
              ? 'translateY(0) scale(1)'
              : `translateY(${introOffset}px) scale(1.15)`,
          transition: 'opacity 0.8s ease, transform 1.1s cubic-bezier(0.22, 1, 0.36, 1)',
        }}
      >
        <Card.Text>
            Texas is home to an unrivaled class of high caliber creative as well as
        business professionals, and it's the 2nd Team Productions mission to
        communicate this reality to the entertainment industry at large.
        </Card.Text>
      </blockquote>
          </div>

      <div className="container">
        <div className="about-page-content text-center">

            {/* Headshot + name */}
          <div
            className="d-flex flex-column align-items-center"
            style={{ ...reveal(0.1), marginBottom: '1rem', width: '100%' }}
          >
            <img
              src={nick}
              alt="Nick"
              className="img-fluid"
              style={{
                width: '45%',
                maxWidth: '300px',
                borderRadius: '50%',
                border: '2px solid rgba(28, 26, 26, 0.9)',
                boxShadow: `
                  0 2px 0 rgba(255, 255, 255, 0.03) inset,
                  0 -2px 0 rgba(0, 0, 0, 0.5) inset,
                  0 12px 24px rgba(0, 0, 0, 0.6),
                  0 32px 64px rgba(0, 0, 0, 0.5),
                  0 64px 100px rgba(0, 0, 0, 0.35)
                `,
              }}
            />
            <h2 className="mt-4 mb-1 text-center">Nicholas James Ortiz</h2>
            <h2 className="text-muted mb-3 text-center">Founder</h2>
          </div>

          {/* Bio */}
          <Card
            className="card-body text-start"
            style={{ ...reveal(0.4), padding: '3%', marginLeft: '6%', marginRight: '6%' }}
          >
            <Card.Text>
              Nicholas is CTO of Robert Rodriguez's Brass Knuckle Films and an
              Austin-based Actor whose most recent role is in Robert Rodriguez's
              SpyKids: Armageddon. Since wrapping SpyKids, he was admitted into the
              Austin Film Society's Producer Program on scholarship. Aware that many
              shows filmed in Texas are comprised of cast and crew not local to the
              state, Nicholas has endeavored to improve the visibility of the local
              film community.
            </Card.Text>
                  <div
            className="d-flex justify-content-center"
            style={{ ...reveal(1), gap: '16px', marginTop: '.3rem' }}
          >
            <a href="https://www.imdb.com/name/nm13929885/" target="_blank" rel="noreferrer">
              <img src={IMDBSVG} alt="IMDb" style={{ height: '32px' }} />
            </a>
            <a href="https://www.linkedin.com/in/nicholasjortiz/" target="_blank" rel="noreferrer">
              <img src={LISVG} alt="LinkedIn" style={{ height: '32px' }} />
            </a>
          </div>
          </Card>
          
          <div className="d-flex justify-content-center"
          style={{ ...reveal(0.85), marginTop: '3rem' }}
          >
          <Button
             href={CONTACT_HREF}
            className="process-card-text hover-brighten"
            style={{
              fontSize: '2.5vmin',
              backgroundColor: 'rgb(67, 66, 66)',
              border: '2px solid rgba(28, 26, 26, 0.9)',
              boxShadow: `
                0 2px 0 rgba(255, 255, 255, 0.12) inset,
                0 -1px 0 rgba(0, 0, 0, 0.45) inset,
                0 6px 12px rgba(0, 0, 0, 0.5),
                0 12px 24px rgba(0, 0, 0, 0.35)
              `,
              borderRadius: '999px',
              cursor: 'pointer',
              padding: '.5rem .1rem',
            }}
          >
            <h5 style={{ margin: '1%' }}>Start the Conversation</h5>
          </Button>
        </div>
         
        </div>
      </div>
    </div>
  );
}